module.exports = __webpack_public_path__ + "static/media/creditcard-cvc.94e93f02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/creditcard-cvc.svg
// module id = 1002
// module chunks = 0